import { CarePhase } from '@shared';
import { OnboardingCarePhases, OnboardingCarePhasesPhaseOne } from '@/pages/OnboardingCarePhases';

export function GenworthOnboardingCarePhasesPhaseOne(_props: ClientIdProps) {
  return (
    <OnboardingCarePhases
      carePhase={CarePhase.earlyCare}
      slidePage={OnboardingCarePhasesPhaseOne}
      title="How a typical care timeline progresses"
    />
  );
}
